import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.search.lastResult;

const getSearchLastResult = createSelector(getData, lastResult => lastResult);

export default getSearchLastResult;



// WEBPACK FOOTER //
// ./src/_selectors/searchSelectors/getSearchLastResult.js